/**
 * Critères checklist configuration boutique — logique pure (compteur inchangé).
 */
export function buildSetupChecklistItems({
  commercant,
  accountStatus,
  produitsCount = 0,
  prestationsCount = 0,
  zonesCount = 0,
  isSuperAdmin = false,
}) {
  const horairesOk = Array.isArray(commercant.horaires) && commercant.horaires.length > 0;
  const logoOk = Boolean(commercant.logo);
  const catalogueOk =
    (commercant.moduleProduits && produitsCount > 0) ||
    (commercant.modulePrestations && prestationsCount > 0);
  const compteOk = accountStatus === 'LINKED';
  const livraisonOk = !commercant.livraison || zonesCount > 0;
  const paiementOk = commercant.paiementEnLigne || commercant.paiementSurPlace;

  return [
    {
      id: 'logo',
      label: 'Logo renseigné',
      ok: logoOk,
      tab: 'overview',
      section: 'logo',
    },
    {
      id: 'horaires',
      label: 'Horaires configurés',
      ok: horairesOk,
      tab: 'overview',
      section: 'horaires',
    },
    {
      id: 'compte',
      label: 'Compte commerçant lié',
      ok: compteOk,
      tab: isSuperAdmin ? 'identifiants' : null,
      href: isSuperAdmin ? null : '/staff',
      hint: accountStatus === 'MISSING' ? 'Compte manquant' : accountStatus === 'NO_EMAIL' ? 'Email boutique requis' : null,
    },
    {
      id: 'catalogue',
      label: commercant.modulePrestations ? 'Prestations ou produits' : 'Au moins un produit',
      ok: catalogueOk,
      tab: commercant.modulePrestations && prestationsCount > 0 ? 'prestations' : 'produits',
    },
    {
      id: 'paiement',
      label: 'Mode de paiement activé',
      ok: paiementOk,
      tab: 'overview',
      section: 'services',
    },
    ...(commercant.livraison
      ? [
          {
            id: 'zones',
            label: 'Zone(s) de livraison',
            ok: livraisonOk,
            tab: 'zones',
          },
        ]
      : []),
  ];
}
